// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loader Animation CSS */

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.loader-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  z-index: 9999;
}

/* Size variants */
.loader-sm .dot {
  width: 6px;
  height: 6px;
}

.loader-md .dot {
  width: 12px;
  height: 12px;
}

.loader-lg .dot {
  width: 16px;
  height: 16px;
}

/* Dot animation variant */
.loader-dots .dot {
  background-color: #4f46e5;
  border-radius: 50%;
  display: inline-block;
  margin: 0 4px;
  animation: bounce 1.4s infinite ease-in-out both;
}

.loader-dots .dot-1 {
  animation-delay: -0.32s;
}

.loader-dots .dot-2 {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Spinner animation variant */
.loader-spinner {
  position: relative;
  width: 40px;
  height: 40px;
}

.loader-spinner .dot {
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: #4f46e5;
  border-radius: 50%;
  animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.loader-spinner .dot-1 {
  animation-delay: -0.36s;
  top: 0;
  left: 14px;
}

.loader-spinner .dot-2 {
  animation-delay: -0.18s;
  top: 8px;
  left: 22px;
}

.loader-spinner .dot-3 {
  top: 14px;
  left: 14px;
}

@keyframes spin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* Pulse animation variant */
.loader-pulse .dot {
  background-color: #4f46e5;
  border-radius: 50%;
  display: inline-block;
  margin: 0 4px;
  animation: pulse 1.5s ease-in-out infinite;
}

.loader-pulse .dot-1 {
  animation-delay: 0s;
}

.loader-pulse .dot-2 {
  animation-delay: 0.3s;
}

.loader-pulse .dot-3 {
  animation-delay: 0.6s;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}

/* Inline dots loader */
.loader-dots-sm {
  display: inline-flex;
  gap: 3px;
}

.loader-dots-sm .dot {
  width: 6px;
  height: 6px;
  background-color: #4f46e5;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.loader-dots-sm .dot-1 {
  animation-delay: -0.32s;
}

.loader-dots-sm .dot-2 {
  animation-delay: -0.16s;
}

/* Label styling */
.loader-label {
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
  margin: 0.5rem 0 0 0;
  animation: pulse-text 2s ease-in-out infinite;
}

@keyframes pulse-text {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Loader.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;;;IAGE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;EACvB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["/* Loader Animation CSS */\n\n.loader-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.loader-fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.95);\n  z-index: 9999;\n}\n\n/* Size variants */\n.loader-sm .dot {\n  width: 6px;\n  height: 6px;\n}\n\n.loader-md .dot {\n  width: 12px;\n  height: 12px;\n}\n\n.loader-lg .dot {\n  width: 16px;\n  height: 16px;\n}\n\n/* Dot animation variant */\n.loader-dots .dot {\n  background-color: #4f46e5;\n  border-radius: 50%;\n  display: inline-block;\n  margin: 0 4px;\n  animation: bounce 1.4s infinite ease-in-out both;\n}\n\n.loader-dots .dot-1 {\n  animation-delay: -0.32s;\n}\n\n.loader-dots .dot-2 {\n  animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n  0%,\n  80%,\n  100% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Spinner animation variant */\n.loader-spinner {\n  position: relative;\n  width: 40px;\n  height: 40px;\n}\n\n.loader-spinner .dot {\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  background-color: #4f46e5;\n  border-radius: 50%;\n  animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n}\n\n.loader-spinner .dot-1 {\n  animation-delay: -0.36s;\n  top: 0;\n  left: 14px;\n}\n\n.loader-spinner .dot-2 {\n  animation-delay: -0.18s;\n  top: 8px;\n  left: 22px;\n}\n\n.loader-spinner .dot-3 {\n  top: 14px;\n  left: 14px;\n}\n\n@keyframes spin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n/* Pulse animation variant */\n.loader-pulse .dot {\n  background-color: #4f46e5;\n  border-radius: 50%;\n  display: inline-block;\n  margin: 0 4px;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n.loader-pulse .dot-1 {\n  animation-delay: 0s;\n}\n\n.loader-pulse .dot-2 {\n  animation-delay: 0.3s;\n}\n\n.loader-pulse .dot-3 {\n  animation-delay: 0.6s;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 0.3;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n/* Inline dots loader */\n.loader-dots-sm {\n  display: inline-flex;\n  gap: 3px;\n}\n\n.loader-dots-sm .dot {\n  width: 6px;\n  height: 6px;\n  background-color: #4f46e5;\n  border-radius: 50%;\n  animation: bounce 1.4s infinite ease-in-out both;\n}\n\n.loader-dots-sm .dot-1 {\n  animation-delay: -0.32s;\n}\n\n.loader-dots-sm .dot-2 {\n  animation-delay: -0.16s;\n}\n\n/* Label styling */\n.loader-label {\n  color: #6b7280;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin: 0.5rem 0 0 0;\n  animation: pulse-text 2s ease-in-out infinite;\n}\n\n@keyframes pulse-text {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
